var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 -4 13.1 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6700",
    d: "M13 .7c-.2-.5-.6-.7-1.1-.7H1.3C.8 0 .3.2.2.7S-.1 1.7.3 2L5 6.8v7.6c0 .7.8 1.2 1.5 1.2S8 15 8 14.4V7l4.8-5c.4-.3.4-.8.2-1.3z"
  })));
}

export default SvgFilterActive;